import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { CHATBOT_EDITOR } from '../../constants/routes';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import CreateRemoteLandingPage from './CreateRemoteLandingPage';
import CreateRemoteShareLink from './CreateRemoteShareLink';
import CreateRemoteCustomerChat from './CreateRemoteCustomerChat';
import { CreateRemoteSMSKeyword } from './CreateRemoteSMSKeyword';

export enum EntityType {
  shareLink = 'link',
  landingPage = 'landing-page',
  customerChat = 'customer-chat',
  smsKeyword = 'sms-keyword',
}

type Props = {
  entityType: EntityType;
};

const useRedux = () => {
  const { botId, fbPage } = useSelector(
    (state: StoreState) => ({
      botId: activeChatbotIdSelector(state),
      fbPage: activeFacebookPageSelector(state),
    }),
    shallowEqual,
  );

  return {
    botId,
    fbPage,
  };
};

const CreateRemoteEntity = ({ entityType }: Props) => {
  const { botId, fbPage } = useRedux();

  switch (entityType) {
    case EntityType.landingPage:
      return (
        <CreateRemoteLandingPage
          botId={botId}
          botRoute={`${CHATBOT_EDITOR}/${botId}`}
          fbPageName={fbPage?.name}
          fbPageId={fbPage?.id}
        />
      );
    case EntityType.shareLink:
      return (
        <CreateRemoteShareLink
          botId={botId}
          botRoute={`${CHATBOT_EDITOR}/${botId}`}
        />
      );
    case EntityType.customerChat:
      return <CreateRemoteCustomerChat botId={botId} />;
    case EntityType.smsKeyword:
      return <CreateRemoteSMSKeyword />;
    default:
      throw Error('Unknown EntityType');
  }
};

export default CreateRemoteEntity;
